import { useMemo } from 'react';
import { ThemeProvider as MuiThemeProvider, CssBaseline } from '@mui/material';
import { createAppTheme } from './theme';
import { useBranding } from './brandingContext';

/**
 * App theme provider.
 * Recreates the MUI theme when tenant branding (primary/secondary colors) loads.
 * The Piper redesign ships light-first; dark scheme plumbing is retained
 * (MUI `useColorScheme` persists under the "mui-mode" key) but defaults to light.
 */
export const ThemeProvider = ({ children }) => {
  const { branding } = useBranding();

  const theme = useMemo(
    () =>
      createAppTheme({
        primaryColor: branding?.primaryColor,
        secondaryColor: branding?.secondaryColor,
      }),
    [branding?.primaryColor, branding?.secondaryColor],
  );

  return (
    <MuiThemeProvider theme={theme} defaultMode="light" disableTransitionOnChange>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};

export default ThemeProvider;
